export default "__VITE_ASSET__D3R9St7p__"